var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoAddressSea = function SvgNoAddressSea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_8150",
    "data-name": "Grupo 8150",
    width: 105.567,
    height: 140.18,
    viewBox: "0 0 215.567 273.18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3434",
    "data-name": "Ret\\xE2ngulo 3434",
    width: 215.567,
    height: 273.18,
    fill: "#d98c06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3433",
    "data-name": "Ret\\xE2ngulo 3433",
    width: 215.566,
    height: 273.18,
    fill: "#d98c06"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8155",
    "data-name": "Grupo 8155",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8154",
    "data-name": "Grupo 8154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8153",
    "data-name": "Grupo 8153",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8152",
    "data-name": "Grupo 8152",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8151",
    "data-name": "Grupo 8151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8150-2",
    "data-name": "Grupo 8150",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5638",
    "data-name": "Caminho 5638",
    d: "M12.059,31.676c-1.229,1.257-2.24,2.711-3.353,4.077v3.128a8.219,8.219,0,0,0,4.473,4.466h2.684a33.327,33.327,0,0,0,4.084-2.964c5.368-5.238,10.647-10.572,15.947-15.892.553-.546,1.065-1.134,1.25-1.332-2.807-2.923-5.409-5.634-8.182-8.523-5.621,5.655-11.3,11.316-16.9,17.04",
    transform: "translate(50.752 85.32)",
    fill: "#d98c06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5639",
    "data-name": "Caminho 5639",
    d: "M81.906,148.733a54.778,54.778,0,1,1,64.744-64.75l29.831-29.831C161.347,22.121,129.713,0,93.011,0,41.639,0,0,43.224,0,96.535c0,23.671,18.324,61.076,38.71,95.388Z",
    fill: "#d98c06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5640",
    "data-name": "Caminho 5640",
    d: "M44.367,22.893c-.669-.731-1.509-1.66-2.7-2.984-3.572,3.592-7.055,7.109-10.354,10.429-.861-.738-1.742-1.489-2.923-2.5q5.409-5.378,10.4-10.313c-.82-.888-1.646-1.789-2.67-2.9-3.49,3.545-6.911,7.014-10.319,10.47-.922-.833-1.742-1.571-2.827-2.568,3.708-3.6,7.219-7.007,10.77-10.463-1.059-1.12-1.919-2.028-2.889-3.039-4.507,4.507-8.837,8.892-13.229,13.208a10.977,10.977,0,0,0-3.606,7.656,3.524,3.524,0,0,0,.69,2.295c2.226,2.4,4.576,4.692,6.932,6.966.423.4,1.209.9,1.646.758,2.37-.731,5.218-1.065,6.918-2.616,4.979-4.535,9.493-9.582,14.164-14.4",
    transform: "translate(81.705 52.594)",
    fill: "#d98c06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5641",
    "data-name": "Caminho 5641",
    d: "M40.336,49.82c.71.765,1.38,1.455,2.015,2.165Q49.4,59.873,56.467,67.754l8.018-8.025Q40.012,35.266,15.538,10.817a6.59,6.59,0,0,0-1.284-1.229c-1.141-.608-2.547-1.1-3.176.471-2.732,6.666-2.9,14.13,2.95,19.806,6.42,6.215,12.689,12.594,19,18.925,1.339,1.345,2.575,2.8,3.886,4.234,1.373-1.291,2.343-2.192,3.422-3.2",
    transform: "translate(53.911 52.5)",
    fill: "#d98c06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5642",
    "data-name": "Caminho 5642",
    d: "M204.432,8.484a6.822,6.822,0,0,0-9.657,0L3.569,199.689a6.828,6.828,0,1,0,9.657,9.657l31.2-31.2c20.687,32.235,39.468,57.17,39.454,57.258,1,.505,93.011-123.327,93.011-176.645a100.334,100.334,0,0,0-.84-12.238L204.432,18.14a6.822,6.822,0,0,0,0-9.657",
    transform: "translate(9.133 37.779)",
    fill: "#d98c06"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAddressSea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_address_sea.dcc60088.svg";
export { ForwardRef as ReactComponent };